module.exports = __webpack_public_path__ + "static/img/kuangjing.92d54c53.png";